// src/utils/getPublicPath.ts

// Join base + path safely with single slash
const joinUrl = (base: string, p: string) => {
  const b = (base || '').replace(/\/+$/, '');         // trim trailing /
  const s = ('/' + p).replace(/\/{2,}/g, '/');        // ensure leading / and collapse //
  return `${b}${s}`;
};

// PUBLIC_BASE: if PUBLIC_URL is undefined or ".", use site root.
// If you ever deploy under a subpath, set PUBLIC_URL to that (e.g. "/portfolio").
const PUBLIC_BASE = (() => {
  const v = process.env.PUBLIC_URL;
  if (!v || v === '.') return ''; // root
  return v;
})();

// Always build URLs from site root (or PUBLIC_URL subpath)
const getPath = (path: string) => {
  const clean = String(path).replace(/^\/+/, ''); // drop leading slashes
  return joinUrl(PUBLIC_BASE, clean);
};

/** Public helpers */
export const getSongPath = (song: string) => getPath(`songs/${song}`);

export const getAlbumPath = (
  album: string,
  lang: string = 'en',
  ext: 'png' | 'jpg' | 'webp' = 'png'
) => {
  // Fallback to EN for langs we don't have
  const fallbackLang = ['fr', 'it', 'de'].includes(lang) ? 'en' : lang;
  return getPath(`images/albums/${album}-${fallbackLang}.${ext}`);
};

export const getSocialNetworkPath = (file: string) =>
  getPath(`images/social/${file}`);

export const getProjectPath = (file: string) =>
  getPath(`images/projects/${file}`);

export const getExperiencePath = (file: string) =>
  getPath(`images/experience/${file}`);

export const getEducationPath = (file: string) =>
  getPath(`images/education/${file}`);

export const getPublicationPath = (file: string) =>
  getPath(`images/publications/${file}`);
